<template>
  <v-app>
  <v-container>
    <v-data-table
      v-model:expanded="expanded"
      v-model:items-per-page="itemsPerPage"
      :headers="visibleHeaders"
      :items="filteredItems"
      class="elevation-1"
      @click:row="handleClick"
      item-value="No."
      show-expand
    >
      <template v-slot:expanded-row="{ columns, item }">
        <tr>
          <td :colspan="columns.length">
            <strong>例句:</strong>
            <span class="clickable" @click="speak(item.exampleSentence, $event)">
              {{ item.exampleSentence }}
            </span>
            <br>
            <strong>例句拼音:</strong> {{ item.examplePinyin }}
            <br>
            <strong>例句的日語:</strong> {{ item.exampleJapanese }}
          </td>
        </tr>
      </template>

      <template v-slot:[`item.Vocabulary`]="{ item }">
        <span class="clickable" @click="speak(item.Vocabulary, $event)">{{ item.Vocabulary }}</span>
        <!-- <v-btn icon @click="speak(item.Vocabulary, $event)">
          <v-icon>mdi-volume-high</v-icon>
        </v-btn> -->
      </template>

      <template v-slot:[`item.exampleSentence`]="{ item }">
        <span class="clickable" @click="speak(item.exampleSentence, $event)">{{ item.exampleSentence }}</span>
      </template>

      <template v-slot:[`item.japaneseMeaning`]="{ item }">
        <span>{{ item.japaneseMeaning }}</span>
        <v-tooltip
          activator="parent"
          location="bottom"
          v-model="item.tooltipENG"
        >{{item.englishMeaning}}</v-tooltip>
      </template>

      <template v-slot:[`item.englishMeaning`]="{ item }">
        <span>{{ item.englishMeaning }}</span>
        <v-tooltip
          activator="parent"
          location="bottom"
          v-model="item.tooltipJPN"
        >{{item.japaneseMeaning}}</v-tooltip>
      </template>

      <template v-slot:top>
        <v-row dense>
          <v-col cols="12" sm="3">
            <v-select
              v-model="searchScope"
              :items="searchScopeOptions"
              label="検索範囲"
              solo
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-text-field v-model="search" label="検索" solo></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="4">
            <v-select
              v-model="levelFilter"
              :items="levelOptions"
              label="レベル"
              solo
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4">
            <v-select
              v-model="contextFilter"
              :items="contextOptions"
              label="任務領域でのフィルター"
              solo
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4">
            <v-select
              v-model="posFilter"
              :items="partsOfSpeechOptions"
              label="詞類でのフィルター"
              solo
              clearable
            ></v-select>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" class="d-flex flex-wrap">
            <v-checkbox
              v-for="header in headers"
              :key="header.key"
              v-model="visibleColumns[header.key]"
              :label="header.title"
              class="mr-4 mb-2"
            ></v-checkbox>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title>単語の詳細</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <span class="clickable-headline" @click="speak(selectedWord.Vocabulary, $event)">{{ selectedWord.Vocabulary }}</span>
              <span> - {{ selectedWord.Pinyin }}  </span>
              <span class="caption">({{ selectedWord.PartsOfSpeech }}/{{ selectedWord.PartsOfSpeech2 }})</span>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col cols="12">
              <!-- <div><strong>Level:</strong> {{ selectedWord.Level }}</div> -->
              <div><strong>英語的意思:</strong> {{ selectedWord.englishMeaning }}</div><br>
              <div><strong>日語的意思:</strong> {{ selectedWord.japaneseMeaning }}</div><br>
              <div><strong>例句:</strong><span class="clickable" @click="speak(selectedWord.exampleSentence, $event)"> {{ selectedWord.exampleSentence }}</span></div>
              <div><strong>例句拼音:</strong> {{ selectedWord.examplePinyin }}</div>
              <div><strong>例句的日語:</strong> {{ selectedWord.exampleJapanese }}</div>
              <div><a :href="`https://www.moedict.tw/${selectedWord.Vocabulary}`" target="_blank" class="clickable">{{ selectedWord.Vocabulary }}を萌典(moedict)で開く</a></div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  </v-container>
</v-app>
</template>

<script>
import Vokabelliste from '/src/assets/wordlist.json'

export default {
  name: 'WordList',
  data() {
    return {
      searchScope: null,
      searchScopeOptions: ['全部', '詞彙', '日語的意思', '例句', '例句の日本語'],
      headers: [
        { title: 'No.', key: 'No.', visible: false },
        { title: 'Level', key: 'Level', visible: false },
        { title: '任務領域', key: 'Context', visible: false },
        { title: '詞彙', key: 'Vocabulary', visible: true },
        { title: '拼音', key: 'Pinyin', visible: true },
        { title: '詞類', key: 'PartsOfSpeech', visible: false },
        { title: '詞類2', key: 'PartsOfSpeech2', visible: false },
        { title: '英語的意思', key: 'englishMeaning', visible: true },
        { title: '日語的意思', key: 'japaneseMeaning', visible: false },
        // { title: '例句', key: 'exampleSentence', visible: false },
        // { title: '例句拼音', key: 'examplePinyin', visible: false },
        // { title: '例句的日語', key: 'exampleJapanese', visible: false },
      ],
      visibleColumns: {},
      vocabulary: Vokabelliste,
      search: '',
      contextFilter: null,
      posFilter: null,
      levelFilter: null,
      contextOptions: [...new Set(Vokabelliste.map(i => i.Context))],
      partsOfSpeechOptions: [...new Set(Vokabelliste.map(i => i.PartsOfSpeech))],
      levelOptions: [...new Set(Vokabelliste.map(i => i.Level))],
      dialog: false,
      selectedWord: {},
      itemsPerPage: 5,
      expanded: [],
    }
  },
  created() {
    this.headers.forEach(header => {
      this.visibleColumns[header.key] = header.visible
    })
  },
  computed: {
    visibleHeaders() {
      return this.headers.filter(header => this.visibleColumns[header.key])
    },
    filteredItems() {
      return this.vocabulary.filter(item => {
        const s = this.search.toLowerCase()
        const matchesSearch = 
          this.searchScope === '全部'
            ? item.Vocabulary.toLowerCase().includes(s) ||
              item.japaneseMeaning.toLowerCase().includes(s) ||
              item.exampleSentence.toLowerCase().includes(s) ||
              item.exampleJapanese.toLowerCase().includes(s)
            : this.searchScope === '詞彙'
              ? item.Vocabulary.toLowerCase().includes(s)
              : this.searchScope === '日語的意思'
                ? item.japaneseMeaning.toLowerCase().includes(s)
                : this.searchScope === '例句'
                  ? item.exampleSentence.toLowerCase().includes(s)
                  : item.exampleJapanese.toLowerCase().includes(s);

        const matchesContext =
          !this.contextFilter || item.Context === this.contextFilter
        const matchesPos =
          !this.posFilter || item.PartsOfSpeech === this.posFilter
        const matchesLevel =
          !this.levelFilter || item.Level === this.levelFilter
        return matchesSearch && matchesContext && matchesPos && matchesLevel
      })
    }
  },
  methods: {
    speak(text, event) {
      event.stopPropagation();
      const synth = window.speechSynthesis;
      if (!synth) {
        console.error('SpeechSynthesis not supported.');
        return;
      }

      const speakUtterance = () => {
        const voices = synth.getVoices();
        console.log(voices);
        var zhTWVoice = voices.find(voice => voice.name.startsWith('Google 國語（臺灣）'));
        if (!zhTWVoice) {
          zhTWVoice = voices.find(voice => voice.name.startsWith('Meijia (Chinese (Taiwan))'));
        }
        if (!zhTWVoice) {
          zhTWVoice = voices.find(voice => voice.lang.startsWith('zh_TW') || voice.lang.startsWith('zh-TW'));
        }

        if (zhTWVoice) {
          const utterThis = new SpeechSynthesisUtterance(text);
          utterThis.voice = zhTWVoice;
          utterThis.lang = 'zh-TW';
          synth.cancel();
          synth.speak(utterThis);
        } else {
          console.error('zh-TW voice not found.');
        }
      };

      // If voices are already loaded
      if (synth.getVoices().length !== 0) {
        speakUtterance();
      } else {
        // Wait for voices to load
        synth.addEventListener('voiceschanged', speakUtterance);
      }
    },
    handleClick(event, row) {
      console.log("Clicked item: ", row.item)
      this.selectedWord = row.item
      this.dialog = true
    }

  }
}
</script>

<style>
.clickable {
  cursor: pointer;
  color: dodgerblue;
  text-decoration: underline;
}

.headline {
  font-size: 1.5em;
  font-weight: bold;
}

.clickable-headline {
  cursor: pointer;
  color: dodgerblue;
  text-decoration: underline;
  font-size: 1.5em;
  font-weight: bold;
}

.caption {
  font-size: 0.85em;
  color: gray;
}

.my-4 {
  margin-top: 16px;
  margin-bottom: 16px;
}
</style>